import React from "react";
import EntityPage from "@/components/EntityPage";
import { useRefData } from "@/context/RefDataContext";

export default function ServicesPage() {
  const ref = useRefData();

  const columns = [
    { key: "code", label: "Service ID", render: (s) => <span className="font-mono text-xs text-zinc-400">{s.code}</span> },
    { key: "service_type", label: "Service Type", render: (s) => <span className="text-white">{s.service_type}</span> },
    { key: "service_provider_name", label: "Provider" },
    { key: "manager_name", label: "Manager" },
    { key: "service_provider_support_number", label: "Support #" },
  ];

  const fields = [
    { key: "service_type", label: "Service Type", type: "select", optionsRef: "service_types", required: true },
    { key: "service_provider_name", label: "Service Provider", required: true },
    { key: "service_provider_support_number", label: "Support Center #" },
    { key: "relationship_number", label: "Relationship #" },
    { key: "project_id", label: "CDARK", type: "select", optionsRef: "projects" },
    { key: "manager_name", label: "Manager Name" },
    { key: "manager_email", label: "Manager Email", type: "email" },
    { key: "contact_number", label: "Contact Number" },
    { key: "extension_number", label: "Extension" },
    { key: "description", label: "Notes", type: "textarea", full: true },
    { key: "contact_persons", label: "Contact Persons", type: "contacts", full: true },
  ];

  const initial = {
    service_type: "",
    service_provider_name: "",
    service_provider_support_number: "",
    relationship_number: "",
    project_id: "",
    manager_name: "",
    manager_email: "",
    contact_number: "",
    extension_number: "",
    description: "",
    contact_persons: [],
  };

  return (
    <EntityPage
      title="Services"
      subtitle="Service providers, contracts and support contacts."
      testidPrefix="services"
      endpoint="/services"
      columns={columns}
      fields={fields}
      initialForm={initial}
      referenceData={ref}
    />
  );
}
